import React from 'react'
import Top from './Top'
import Footer from './Footer'
import Sponsors from './Sponsors'
import { Helmet } from 'react-helmet'

const LayoutLldd = (props) => (
    <>
        <Helmet>
            <title>{props.title ? props.title : 'La Leyenda del Dorado'}</title>
            <meta name="description" content={props.description ? props.description : 'La Leyenda, South Americas most prestigious mountain bike stage race, where adventurous professional and amateur cyclists from around the world race side by side in the majestic Andean mountains of Colombia.'} />
        </Helmet>
        <div className="container-fluid">
            <Top/>
            {props.children}
            <Sponsors/>
            <Footer/>
        </div>
    </>
)

export default LayoutLldd;